// #region Imports

import { darken, lighten } from './adjust';
import { generateAnalogousColor, generateAnalogousPalette } from './generators/analogous';
import { generateComplementaryColor, generateComplementaryPalette } from './generators/complementary';
import { generateMaterialPalette } from './generators/material';
import { generateSplitComplementaryColor1, generateSplitComplementaryColor2, generateSplitComplementaryColors } from './generators/split-complementary';
import { generateTetradicColor1, generateTetradicColor3, generateTetradicColors } from './generators/tetradic';
import { generateTriadicColor, generateTriadicPalette } from './generators/triadic';

// #endregion

export namespace Colors {
    export const toDarken = darken;
    export const toLighten = lighten;
    export const toMaterialPalette = generateMaterialPalette;
    export const toComplementaryPalette = generateComplementaryPalette;
    export const toComplementaryColor = generateComplementaryColor;
    export const toAnalogousPalette = generateAnalogousPalette;
    export const toAnalogousColor = generateAnalogousColor;
    export const toTriadicPalette = generateTriadicPalette;
    export const toTriadicColor = generateTriadicColor;
    export const toSplitComplementaryColors = generateSplitComplementaryColors;
    export const toSplitComplementaryColor1 = generateSplitComplementaryColor1;
    export const toSplitComplementaryColor2 = generateSplitComplementaryColor2;
    export const toTetradicColors = generateTetradicColors;
    export const toTetradicColor1 = generateTetradicColor1;
    export const toTetradicColor3 = generateTetradicColor3;
}
